import { useEffect } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import useCompetitions from 'hooks/useCompetitions';
import useCompetitionStore from 'store/competitionStore';
import Page from 'components/system/Page';
import CompetitionItem from 'components/pages/Competitions/CompetitonItem';
import { useNavigate } from 'react-router-dom';
import useJoinedCompetitions from 'hooks/useJoinedCompetitions';
import CompetitionLoader from 'components/pages/Competition/ContentLoader/CompetitionLoader';

const CompetitionsPage = ({ isMobile }) => {
  const navigate = useNavigate();
  useCompetitions();
  useJoinedCompetitions();

  const competitions = useCompetitionStore((state) => state.competitions);
  const isLoading = useCompetitionStore((state) => state.isLoading);

  useEffect(() => {
    if (!isLoading && competitions?.length >= 1) {
      let competitionToNavigate;
      const [firstCompetition] = competitions;

      if (competitions.length === 1) {
        // If there's only one competition, use that one
        competitionToNavigate = firstCompetition;
      } else {
        // Find the competition with the latest start date
        competitionToNavigate = competitions.reduce((latest, current) => {
          // Convert start dates to Date objects for comparison
          const latestDate = new Date(latest.start);
          const currentDate = new Date(current.start);

          // Return the competition with the later start date
          return currentDate > latestDate ? current : latest;
        }, firstCompetition);
      }

      if (competitionToNavigate) {
        navigate(`/hackathons/${competitionToNavigate.competitionId}`);
      }
    }
  }, [isLoading, competitions, navigate]);

  // return !isLoading && competitions.length > 1 ? (
  //   <Container>
  //     <Page
  //       title="Hackathons"
  //       subTitle="Grow your data science skills by competing in our exciting Hackathons."
  //     >
  //       <Grid container spacing={2} sx={{ marginTop: 0 }}>
  //         {competitions?.map((competition) => (
  //           <Grid item key={competition.competitionId} sx={{ width: '33.3%', minWidth: '355px' }}>
  //             <CompetitionItem
  //               competition={competition}
  //             />
  //           </Grid>
  //         ))}
  //       </Grid>
  //     </Page>
  //   </Container>
  // ) : <CompetitionLoader isMobile={isMobile} />;
  return <CompetitionLoader isMobile={isMobile} />;
};

export default CompetitionsPage;
